import { render, staticRenderFns } from "./PayoutMethodTable.vue?vue&type=template&id=a4554648&"
import script from "./PayoutMethodTable.vue?vue&type=script&lang=js&"
export * from "./PayoutMethodTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports